import React, { useState, useEffect, useContext } from 'react';
import Product from './Product'
import { ProductsContext } from '../../contexts/Products'
import { FormContext, Util } from '@thinkwell/react.common'

export default function ProductsList(props) {
  const [products] = useContext(ProductsContext)
  const form = useContext(FormContext)

  const productsBySku = products.reduce((productsBySku, product) => {
    productsBySku[product.variants[0].sku.toLowerCase()] = product
    return productsBySku
  }, {});

  const skus = form.field("skus") || []

  const MAX_COURSES = props.maxCourses && parseInt(props.maxCourses) || 5

  const containsSku = (skus, sku) => skus.find((_sku) => _sku.toLowerCase() == sku.toLowerCase())

  const onProductClick = (product) => {
    const sku = product.variants[0].sku
    if (containsSku(skus, sku)) {
      const newSkus = skus.filter((s) => s.toLowerCase() != sku.toLowerCase())
      form.onData("skus")(newSkus)
    } else {
      if (skus.length < MAX_COURSES) {
        const newSkus = [].concat(skus, sku)
        form.onData("skus")(newSkus)
      }
    }
  }

  const productsList = skus.map((sku) => productsBySku[sku.toLowerCase()])
  products.forEach((product) => {
    if (!skus || !containsSku(skus, product.variants[0].sku)) {
      productsList.push(product)
    }
  })
  Util.hideLoader();

  return (<div className="grid__item medium-up--one-half products">
      <div>Click on courses you would like to try. They will be highlighted in orange. You can try up to 5 courses at a time. </div>
      <hr/>
      <div className="message">
        <span id="selected-product-count">{skus.length}</span> courses selected.
        { skus.length >= MAX_COURSES ?
          <div id="selected-product-limit-message">{`You've reached the maximum of ${MAX_COURSES} free trial courses.`}</div>
          : null
        }
      </div>
      <div>&nbsp;</div>
      <div className="products-list">
      { productsList.map((product, index) => (
        <Product
          key={index}
          selected={containsSku(skus, product.variants[0].sku)}
          item={product}
          onClick={onProductClick}
        />))}
      </div>
    </div>)
}
